import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage } from "../components/policy-page";
import { loadPolicy, policyHead } from "../lib/policy-route";

/** /privacy: the creator's policy page on their site, Drate's own Privacy page on drate.app. */
export const Route = createFileRoute("/privacy")({
  loader: () => loadPolicy("/privacy"),
  head: ({ matches, loaderData, match }) => policyHead(matches, loaderData, match.pathname),
  component: () => <PolicyPage data={Route.useLoaderData()} />,
});
